
<input #locationElement
	class="form-control"
	[ngClass]="{ 'has-error' : showLocationError && enableError }"
	id="BagLocationAddress" 
	name="BagLocationAddress"
	type="text"
	placeholder=""
	enableError="enableError"
	[(ngModel)]="formattedAddress"
	(blur)="checkLocationInput(locationElement.value)"
	autocomplete="nope"
	required>
<label class="control-label" for="BagLocationAddress">{{ placeholder }}</label>
<p class="help-block text-danger" *ngIf="showLocationError && enableError">Please select an option from the dropdown</p>